import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import * as ForceCategory from "../../../models/force-category.ts";
import * as Styles from "../../styles.ts";
import "../dui/icon/dui-icon.ts";

const styles = css`
  :host {
    --category-icon-size: var(--space-8);
    --category-icon-fg: var(--category-none);
    --category-icon-bg: var(--category-none-bg);
    --icon-size: var(--space-4);

    display: block;
    width: var(--category-icon-size);
    height: var(--category-icon-size);
  }

  .category-icon {
    background-color: var(--category-icon-bg);
    border-radius: calc(var(--category-icon-size) / 2);
    color: var(--icon-fg);
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--category-icon-size);
    height: var(--category-icon-size);
  }

  dui-icon {
    --icon-fg: var(--category-icon-fg);
  }

  .category-icon.social {
    --category-icon-fg: var(--category-social);
    --category-icon-bg: var(--category-social-bg);
  }

  .category-icon.technological {
    --category-icon-fg: var(--category-technological);
    --category-icon-bg: var(--category-technological-bg);
  }

  .category-icon.economic {
    --category-icon-fg: var(--category-economic);
    --category-icon-bg: var(--category-economic-bg);
  }

  .category-icon.environmental {
    --category-icon-fg: var(--category-environmental);
    --category-icon-bg: var(--category-environmental-bg);
  }

  .category-icon.political {
    --category-icon-fg: var(--category-political);
    --category-icon-bg: var(--category-political-bg);
  }
`;

export const getCategoryIcon = (
  category: ForceCategory.ForceCategory | undefined,
): string => {
  switch (category) {
    case "social":
      return "groups";
    case "technological":
      return "laptop_mac";
    case "economic":
      return "paid";
    case "environmental":
      return "nature";
    case "political":
      return "account_balance";
    default:
      return "circle";
  }
};

@customElement("category-icon")
export class CategoryIcon extends LitElement {
  static override styles = [
    Styles.base,
    ForceCategory.forceCategoryStyles,
    styles,
  ];

  @property({
    converter: {
      fromAttribute: ForceCategory.into,
    },
  })
  accessor category: ForceCategory.ForceCategory | undefined = undefined;

  get #categoryIconClasses() {
    return `category-icon ${this.category}`;
  }

  override render() {
    return html`<div class="${this.#categoryIconClasses}">
      <dui-icon icon="${getCategoryIcon(this.category)}"> </dui-icon>
    </div>`;
  }
}
